import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=6c1cfbec&"
import script from "./Setting/Setting.js?vue&type=script&lang=js&"
export * from "./Setting/Setting.js?vue&type=script&lang=js&"
import style0 from "./Setting/Setting.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports